<template>
  <div>
    <a-card title="短信签名列表">
     <a-button slot="extra" type="primary" @click="addSign">新增</a-button>
     <!-- 搜索框 -->
      <a-form layout="inline" @submit="handleSubmit" :form="form">
          <a-form-item>
            <a-form-item label="签名">
                <a-input  v-model="searchP.keyword"  placeholder="签名" ></a-input>
            </a-form-item>
          
            <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
          </a-form-item>

          <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                </a-button>
          </a-form-item>

      </a-form>
    </a-card>

    <!-- 短信签名列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="id" :scroll="{ x: 800}" >
         <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
         <span>
            <router-link
                    :to="{
                    path:'detailSign',
                    query: {
                        id: record.id
                    }
                }"
                >编辑</router-link>
          </span>
          <span>
            <a-popconfirm title="确认删除?" @confirm="() => deleteSign(record)">
              <a>删除</a>
            </a-popconfirm>
          </span>
        </div>
      </template>
    </a-table>

   <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
     
  </div>
</template>
<script>
import { mapState } from "vuex";
const data = [];

let pagination={
    total:0,
    pageSize:0,
    current:1,
}
const columns = [
    {
        title: "序号",
        width: 100,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },{
        title: "ali短信服务签名",
        dataIndex: "signname",
        width:350
    },
    {
        title: "签名对应编码",
        dataIndex: "signnamecode",
        width:400
    },
    {
        title: "服务商编码",
        dataIndex: "servercode",
        width:300,
    },
    {
        title: "商户编码",
        dataIndex: "shopcode",
        width:300
    },
    {
        title: "创建时间",
        dataIndex: "createtime",
        width:300
    },
    {
        title: "修改时间",
        dataIndex: "updatetime",
        width:250
    },
    
    {
        title: "创建人",
        dataIndex: "createuser",
        width:200
    },
    {
        title: "修改人",
        dataIndex: "updateuser",
        width:150
    },
    
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 150,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            pagination,
            tLoading:true,
            currentItemList:'',
            datasource:{
                isShow:false,
                authedStr:''
            },
        
        };
    },
    methods: {

        handlePageChange(c_p){
            this.getSmsSignList(c_p)
        },

        // 查询短信签名列表
        getSmsSignList(cpage){
            let c_params = {
                ...this.searchP
            }
            c_params.page =cpage ? cpage : 1;
            c_params.pageSize = this.pagination.pageSize;
            c_params.urlparams = false;
            this.tLoading = true;
            this.$store.dispatch({
                type: "smsmanager/querySignPageList",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                if(result){
                    this.data = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.current = parseInt(result.page);
                }
            })
        },

        handleSearchReset(){
            this.$store.dispatch({
                type: "smsmanager/getEmptySearch",
                showMsg: true
            })
        },

        handleSubmit(e){
            e.preventDefault();
            this.getSmsSignList(1);

        },

        //新增签名
        addSign(){
            this.$router.push({
                path: "addSign",
                query: {id:''}
            });
        },

        // 删除签名
        deleteSign(key) {
            this.$store.dispatch({
                type: "smsmanager/deleteSign",
                params: {...key}
            }).then((res) => {
                
                if(res.status == '200'){
                    this.getSmsSignList();
                }
            });
        },

        dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                }
            }
            return fmt;
        },

    },
    computed:{
        ...mapState('smsmanager', {
            searchP: state => state.searchP,
        })
    },

    mounted(){
        this.getSmsSignList(1);
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
